// @flow strict
import React from 'react'

import DefaultFooter from './DefaultFooter'

export default function BusinessFooter() {
  return (
    <DefaultFooter
      altLinks={{
        termsAndConditions: {
          label: 'Terms & Conditions',
          href: '/legal/business-account-terms-and-conditions/',
        },
        privacyPolicy: {
          label: 'Privacy Notice',
          href: '/legal/business-account-privacy-notice/',
        },
        informationAboutAccount: {
          label: 'Information about our Business Current Account Services',
          href: '/information-about-business-current-account-services/',
        },
      }}
    />
  )
}
